<template>
    <v-dialog
        v-model="ativarDialog"
        width="50em"
        lazy
        :fullscreen="$vuetify.breakpoint.xs"
        hide-overlay
        scrollable
        @click:outside="
            ativarDialog = false
        "
        @keydown.esc="
            ativarDialog = false
        "
    >
        <v-tooltip bottom slot="activator">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    color='info'
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon>bluetooth_drive</v-icon>
                </v-btn>
            </template>
            <h3>Opcionais</h3>
        </v-tooltip>
        <v-card>
            <v-card-title class="justify-center">
                <v-btn
                    icon
                    color="info"
                    @click="step = 1, opcionalSelecionado = undefined"
                    v-if="step > 1"
                    style="
                        position: absolute;
                        left: 1.5em;
                    "
                >
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <h1>{{ titulo }}</h1>
                <v-btn
                    icon
                    color="info"
                    @click="step = 2"
                    v-if="step === 1"
                    style="
                        position: absolute;
                        right: 1.5em;
                    "
                >
                    <v-icon>add</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-alert v-model="alerta.ativo" :type="alerta.tipo" style="width: 100%;">
                {{ alerta.texto }}
            </v-alert>
            <v-card-text>
                <v-stepper v-model="step" style="box-shadow: none;" class="ma-0 pa-0">
                    <v-stepper-items>
                        <v-stepper-content step="1" class="justify-center ma-0 pa-0">
                            <v-list class="ma-0 pa-0">
                                <v-list-tile v-for="opcional in opcionais" :key="opcional.codigo">
                                    <v-list-tile-avatar>
                                        <v-icon color="info">bluetooth_drive</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ opcional.nome }}</v-list-tile-title>
                                        <v-list-tile-sub-title>
                                            Para {{ ['Todos', 'Motos', 'Carros e Caminhões'][opcional.tipo_veiculo] }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action class="justify-space-around d-inline">
                                        <v-tooltip bottom>
                                            <v-btn
                                                slot="activator"
                                                icon
                                                class="mr-2"
                                                @click="opcionalSelecionado = opcional, step = 3"
                                            >
                                                <v-icon color="error">delete</v-icon>
                                            </v-btn>
                                            <span>Apagar Opcional</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <v-btn
                                                slot="activator"
                                                icon
                                                @click="opcionalSelecionado = opcional, step = 2"
                                            >
                                                <v-icon color="info">edit</v-icon>
                                            </v-btn>
                                            <span>Editar Opcional</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>
                        </v-stepper-content>
                        <v-stepper-content step="2" class="justify-center ma-0 pa-0">
                            <v-form lazy-validation v-model="valido" ref="form">
                                <v-text-field
                                    label="Nome"
                                    outline
                                    v-model="opcional_data.nome"
                                    :rules="[
                                        (v) => !!v || 'Esse campo é obrigatório'
                                    ]"
                                ></v-text-field>
                                <v-text-field
                                    label="Referencia"
                                    outline
                                    v-model="opcional_data.referencia"
                                    readonly
                                    :rules="[
                                        (v) => !!v || 'Esse campo é obrigatório'
                                    ]"
                                ></v-text-field>
                                <v-text-field
                                    label="Código"
                                    outline
                                    type="number"
                                    :disabled="!!opcionalSelecionado"
                                    v-model="opcional_data.codigo"
                                    :rules="[
                                        (v) => !!v || 'Esse campo é obrigatório',
                                        (v) => parseFloat(v) > 0 || 'Valor precisa ser maior que zero',
                                    ]"
                                ></v-text-field>
                                <v-select
                                    label="Tipo do veículo"
                                    outline
                                    type="number"
                                    :items="[
                                        { text: 'Todos os Tipos', value: 0 },
                                        { text: 'Motos', value: 1 },
                                        { text: 'Carros e Caminhões', value: 2 },
                                    ]"
                                    v-model="opcional_data.tipo_veiculo"
                                ></v-select>
                            </v-form>
                        </v-stepper-content>
                        <v-stepper-content step="3" class="justify-center ma-0 pa-0 text-xs-center error--text">
                            <h2 v-if="opcionalSelecionado">Tem certeza que você desaja excluir o opcional "<b>{{ opcionalSelecionado.nome }}</b>"?</h2>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
            <v-card-actions class="ma-0 pa-0 justify-space-around" v-if="step !== 1">
                <v-btn
                    large
                    color="info"
                    block
                    :disabled="!valido"
                    @click="salvarOpcional"
                    v-if="step === 2"
                    flat
                >
                    <v-icon class="mr-2">save</v-icon>
                    Salvar
                </v-btn>
                <template v-else>
                    <v-flex xs6>
                        <v-btn
                            large
                            block
                            @click="step = 1, opcionalSelecionado = undefined"
                            flat
                        >
                            NÃO
                        </v-btn>
                    </v-flex>
                    <v-divider vertical></v-divider>
                    <v-flex xs6>
                        <v-btn
                            large
                            color="error"
                            block
                            @click="apagarOpcional"
                            flat
                        >
                            SIM
                        </v-btn>
                    </v-flex>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({
        step: 1,
        valido: false,
        opcionalSelecionado: undefined,
        opcionais: [],
        ativarDialog: false,
        alerta: {
            tipo: 'error',
            texto: 'Um opcional com esse código já foi cadastrado',
            ativo: false
        },
        opcional_data: {
            nome: '',
            referencia: '',
            tipo_veiculo: 0,
            codigo: 1
        }
    }),
    computed: {
        titulo () {
            if (this.step === 1) return 'OPCIONAIS'
            else if (this.step === 2 && !this.opcionalSelecionado) return 'CADASTRAR OPCIONAL'
            else if (this.step === 2 && this.opcionalSelecionado) return 'EDITAR OPCIONAL'
            else return 'APAGAR OPCIONAL'
        }
    },
    beforeMount () {
        if (this.ativarDialog) this.pegarOpcionais()
    },
    watch: {
        ativarDialog (val) {
            if (val) {
                this.pegarOpcionais()
            } else {
                this.step = 1
                this.$refs.form.reset()
                this.opcionalSelecionado = undefined
            }
        },
        opcionalSelecionado (val) {
            if (val) {
                this.opcional_data = { ...val }
            } else {
                this.$refs.form.reset()
            }
        },
        'opcional_data.nome' (val) {
            if (val !== undefined && val !== null && val !== '') {
                const semConjucoes = val.toLowerCase().normalize('NFD').replace('ç', 'c').replace(/[\u0300-\u036f]/g, '').replace(/\b(e|de|do|da|a|o|as|os|com)\b/g, '')
                const semEspacos = semConjucoes.replace(/\s+/g, '_')
                this.opcional_data.referencia = semEspacos
            } else {
                this.opcional_data.referencia = val
            }
        },
        'opcional_data.codigo' (val) {
            if (val && !this.opcionalSelecionado) this.verificarCodigo()
        }
    },
    methods: {
        ativarAlerta (texto, tipo) {
            this.alerta.texto = texto
            this.alerta.tipo = tipo
            this.alerta.ativo = true
            const interval = setInterval(() => {
                this.alerta.ativo = false
                clearInterval(interval)
            }, 5000)
        },
        pegarOpcionais () {
            const data = {
                method: 'GET'
            }
            this.$store.dispatch('opcionaisVeiculo', data).then(json => {
                this.opcionais = json
            })
        },
        async verificarCodigo () {
            const data = {
                method: 'GET',
                parametros: {
                    codigo: this.opcional_data.codigo
                }
            }
            const json = await this.$store.dispatch('opcionaisVeiculo', data)
            console.log(json)
            if (json.length > 0) {
                this.ativarAlerta('Um opcional com esse código já foi cadastrado', 'error')
            }
        },
        salvarOpcional () {
            if (this.$refs.form.validate()) {
                const data = {
                    method: this.opcionalSelecionado ? 'PUT' : 'POST',
                    body: this.opcional_data,
                    id: this.opcionalSelecionado ? this.opcional_data.codigo : undefined
                }
                this.$store.dispatch('opcionaisVeiculo', data).then(() => {
                    this.pegarOpcionais()
                    this.step = 1
                    this.ativarAlerta(`Opcional ${this.opcionalSelecionado ? 'editado' : 'cadastrado'} com sucesso`, 'success')
                    this.opcionalSelecionado = undefined
                    this.$refs.form.reset()
                })
            }
        },
        apagarOpcional () {
            if (this.$refs.form.validate()) {
                const data = {
                    method: 'DELETE',
                    id: this.opcionalSelecionado ? this.opcional_data.codigo : undefined
                }
                this.$store.dispatch('opcionaisVeiculo', data).then(() => {
                    this.pegarOpcionais()
                    this.step = 1
                    this.ativarAlerta('Opcional deletado com sucesso', 'success')
                    this.opcionalSelecionado = undefined
                })
            }
        }
    }
}
</script>

<style>

</style>
